const KG_TO_LB_FACTOR = 2.2046226218

export function kgToLb(kg: number): number {
  return kg * KG_TO_LB_FACTOR
}

export function lbToKg(lb: number): number {
  return lb / KG_TO_LB_FACTOR
}

export function formatWeight(kg: number, displayUnit: 'kg' | 'lb'): string {
  const value = displayUnit === 'lb' ? kgToLb(kg) : kg
  return `${value.toFixed(1)} ${displayUnit}`
}
